import React from 'react';

import useBackgroundColorClass from '../../../utils/hooks/use_background_color_class';
import { useUserContext } from '../../contexts/UserData/UserData';

import wallarooLogo from '../../../images/wallaroo_logo.svg';

import Button from '../../common/Button/Button';
import ExternalLink from '../../common/Labels/ExternalLink';
import HeadingLabel from '../../common/Labels/HeadingLabel';
import Image from '../../common/Image/Image';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import SubHeadingLabel from '../../common/Labels/SubHeadingLabel';

export const SignedOutView = () => {
  const { isLoggingIn, login } = useUserContext();
  useBackgroundColorClass('bg-brand');

  return (
    <div className="w-full h-full bg-brand flex flex-col justify-center items-center">
      <Image src={wallarooLogo} className="w-44 mt-8 mb-4" alt="Wallaroo logo" />
      <HeadingLabel size="3xl">Please sign in to Wallaroo to continue</HeadingLabel>
      <Button
        size="large"
        variant="primary"
        sx={{
          mt: 2,
          px: 7,
          py: 3,
        }}
        mt={1}
        px={8}
        py={4}
        onClick={login}
      >
        {isLoggingIn ? <LoadingSpinner animationKey="signed-out-spinner" size="medium" /> : 'Sign in'}
      </Button>
      <div className="mt-2 flex flex-row">
        <SubHeadingLabel>Need help?</SubHeadingLabel>
        <ExternalLink
          to="mailto:support@wallaroo.ai"
          className="ml-2"
          color="white"
          hoverColor="border-dark"
          activeColor="border-darker"
          size="xl"
        >
          Contact Wallaroo Support
        </ExternalLink>
      </div>
    </div>
  );
};

export default SignedOutView;
